module.exports = __webpack_public_path__ + "assets/img/dayinji.ec192ac3.png";